module.exports = __webpack_public_path__ + "static/media/ipt_rio_hato_logo2.715072c1.png";